'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.notFound = exports.resetPassword = exports.signin = exports.signup = exports.admin = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _main_layout = require('./components/main_layout');

var _main_layout2 = _interopRequireDefault(_main_layout);

var _home = require('./containers/home');

var _home2 = _interopRequireDefault(_home);

var _orders = require('./containers/orders');

var _orders2 = _interopRequireDefault(_orders);

var _order = require('./containers/order');

var _order2 = _interopRequireDefault(_order);

var _finances = require('./containers/finances');

var _finances2 = _interopRequireDefault(_finances);

var _inout = require('./containers/inout');

var _inout2 = _interopRequireDefault(_inout);

var _users = require('./containers/users');

var _users2 = _interopRequireDefault(_users);

var _user = require('./containers/user');

var _user2 = _interopRequireDefault(_user);

var _levels = require('./containers/levels');

var _levels2 = _interopRequireDefault(_levels);

var _templates = require('./containers/templates');

var _templates2 = _interopRequireDefault(_templates);

var _template_edit = require('./containers/template_edit');

var _template_edit2 = _interopRequireDefault(_template_edit);

var _products = require('./containers/products');

var _products2 = _interopRequireDefault(_products);

var _product_edit = require('./containers/product_edit');

var _product_edit2 = _interopRequireDefault(_product_edit);

var _shipping_templates = require('./containers/shipping_templates');

var _shipping_templates2 = _interopRequireDefault(_shipping_templates);

var _shipping_template_edit = require('./containers/shipping_template_edit');

var _shipping_template_edit2 = _interopRequireDefault(_shipping_template_edit);

var _pickup_stations = require('./containers/pickup_stations');

var _pickup_stations2 = _interopRequireDefault(_pickup_stations);

var _signup = require('./containers/signup');

var _signup2 = _interopRequireDefault(_signup);

var _signin = require('./containers/signin');

var _signin2 = _interopRequireDefault(_signin);

var _reset_password = require('./containers/reset_password');

var _reset_password2 = _interopRequireDefault(_reset_password);

var _auth_wrapper = require('./containers/auth_wrapper');

var _auth_wrapper2 = _interopRequireDefault(_auth_wrapper);

var _media = require('./containers/media');

var _media2 = _interopRequireDefault(_media);

var _banner = require('./containers/banner');

var _banner2 = _interopRequireDefault(_banner);

var _coupons = require('./containers/coupons');

var _coupons2 = _interopRequireDefault(_coupons);

var _account = require('./containers/account');

var _account2 = _interopRequireDefault(_account);

var _resellers = require('./containers/resellers');

var _resellers2 = _interopRequireDefault(_resellers);

var _withdraws = require('./containers/withdraws');

var _withdraws2 = _interopRequireDefault(_withdraws);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var admin = exports.admin = _react2.default.createElement(
    _reactRouter.Route,
    { path: '/', component: (0, _auth_wrapper2.default)(_main_layout2.default) },
    _react2.default.createElement(_reactRouter.IndexRoute, { component: _home2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: 'orders', component: _orders2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: 'orders/:orderID', component: _order2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: 'templates', component: _templates2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: 'templates/:templateID', component: _template_edit2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: 'templates/create', component: _template_edit2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: 'products', component: _products2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: 'products/:productID', component: _product_edit2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: 'products/create', component: _product_edit2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: 'finances', component: _finances2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: 'inout', component: _inout2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: 'users', component: _users2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: 'users/:userID', component: _user2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: 'levels', component: _levels2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: 'pickup', component: _pickup_stations2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: 'express', component: _shipping_templates2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: 'express/:shippingTemplateID', component: _shipping_template_edit2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: 'express/create', component: _shipping_template_edit2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: 'media', component: _media2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: 'banner', component: _banner2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: 'coupons', component: _coupons2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: 'account', component: _account2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: 'resellers', component: _resellers2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: 'withdraws', component: _withdraws2.default })
);

var signup = exports.signup = _react2.default.createElement(_reactRouter.Route, { path: '/signup', component: _signup2.default });
var signin = exports.signin = _react2.default.createElement(_reactRouter.Route, { path: '/signin', component: _signin2.default });
var resetPassword = exports.resetPassword = _react2.default.createElement(_reactRouter.Route, { path: '/reset-password', component: _reset_password2.default });

var notFound = exports.notFound = _react2.default.createElement(
    _reactRouter.Route,
    { path: '*', component: _main_layout2.default },
    _react2.default.createElement(_reactRouter.IndexRoute, { component: _home2.default })
);


//////////////////
// WEBPACK FOOTER
// ./src/js/routes.js
// module id = 917
// module chunks = 0